import { FC, ReactNode } from "react";
import style from "./PrintHeader.module.scss";

export const PrintHeaderRow: FC<{ data: string[]; }> = ({ data }) =>
{

    return <section className={style.printRow}>
        {data.map((value) =>
        {
            return <section
                style={{ width: `${100 / data.length}%` }}
                className={style.printCol}>
                {value}
            </section>;
        })}
    </section>;

};




export const PrintHeader: FC<{ children: ReactNode, title?: string | ReactNode; }> = ({
    title, children
}) =>
{

    return <section className={style.printHeader}>
        <section className={style.printTitle}>
            {title ? <>
                {typeof title === "string" ? <p>{title}</p> : <>{title}</>}
            </> : null}
        </section>
        {children}
    </section>;


};
